export default {
  SEARCH_BOX_PLACEHOLDER: 'Search by Part Number or Coach Number',
};
